var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { mapResourceName } from '@/shared/services/ObjectDisplayService';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';
import { useEffect, useState } from 'react';
export var mapResourcesToTree = function (orgItems, intl) {
    if (!orgItems || !orgItems.length) {
        return [];
    }
    return orgItems
        .filter(function (x) { return x.isDefault && x.categoryId; })
        .reduce(function (array, category) {
        var categoryLabel = mapResourceName(category, intl);
        var subResources = orgItems
            .filter(function (s) { return !s.isDefault && s.categoryId && s.categoryId === category.categoryId; })
            .map(function (resource) {
            var label = mapResourceName(resource, intl, false, true);
            return __assign(__assign({}, resource), { id: resource.id, key: resource.id, model: resource, label: label, categoryLabel: categoryLabel, search: "".concat(categoryLabel, ";").concat(label), level: 1, disabled: resource.disabled });
        });
        // const subResourcesLabels = subResources.map(x => x.label).join(';');
        return array.concat(__spreadArray([
            __assign(__assign({}, category), { id: category.id, key: category.id, model: category, label: categoryLabel, categoryLabel: categoryLabel, search: categoryLabel, level: 0, disabled: category.disabled })
        ], subResources, true));
    }, [])
        .sort(dynamicSortMultiple('categoryLabel', 'level', 'label'));
};
var useResourceTree = function (orgItems, intl) {
    var _a = useState([]), items = _a[0], setItems = _a[1];
    useEffect(function () {
        setItems(mapResourcesToTree(orgItems, intl));
    }, [intl, orgItems]);
    return items;
};
export default useResourceTree;
